// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const StyledTable = styled.table`
    th {
        text-align: left;
    }

    td {
        padding: 2px 10px;
    }
`;